<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-16 16:59:51
 * @LastEditTime: 2019-09-20 13:29:26
 * @LastEditors: Please set LastEditors
 -->
<template>
<div id='page_Container'>
    <div class="page">
        <div id='main-container' class="temporaryHeight main-container">
            <div id="openDistribution" v-show="pageShow">
                <div class="header-img">

                </div>
                <div class="from">
                    <van-cell-group>
                        <van-field v-model="ruleForm.mobilePhone" placeholder="请填写手机号" v-show="!loginFlag"/>
                        <van-field v-model="ruleForm.ivalidateCode" placeholder="请填写验证码" maxlength='4' v-show="!loginFlag">
                            <van-button slot="button" size="small" class="send-btn"  v-bind:class="{sended:!codeButton}" type="primary" id="btn" @click="handleCode"  :disabled="!codeButton">{{codeMsg}}</van-button>
                        </van-field>
                        <van-field v-model="ruleForm.accountTrueName" placeholder="请填写真实姓名，便于提现打款" maxlength='20'/>
                        <van-field v-model="ruleForm.accountIdCard" placeholder="请填写真实身份证号" />
                        <van-field v-model="ruleForm.accountInvitationCode" placeholder="请填写邀请码(可不填)" maxlength='6' :disabled="isShareUser"/>
                    </van-cell-group>
                </div>
                <footer>
                    <van-button size="large" type="primary" :disabled="btndisabled" round @click="submitForm">提交</van-button>
                    <!-- <div class="submit-btn" @click="submitForm">
                        提交
                    </div> -->
                </footer>
            </div>
        </div>
    </div>
    <wxShareLoading></wxShareLoading>
</div>
</template>

<script>
import { Toast } from 'vant';
import { toastLoading, clearToastLoading } from '@/utils/base/utils';
import {
    mapGetters
} from 'vuex';
export default {
    data() {
        return {
            codeMsg: '获取验证码',
            codeButton: true, // 发送验证码按钮 是否禁用
            ruleForm: {
                mobilePhone: '',
                ivalidateCode: '',
                accountTrueName: '',
                accountIdCard: '',
                accountInvitationCode: ''
            },
            codeTime: 60,
            btndisabled: true,
            loginFlag: null,
            pageShow: false,
            isShareUser: false
        };
    },
    esvReady() {
        // let id = this.getCode(window.location.href);
        const id = this.ESVBase.getPramVal('code');
        if (id) {
            this.ruleForm.accountInvitationCode = id;
            this.isShareUser = true;
        } else {
            this.isShareUser = false;
        }
        console.log(id);
        this.queryMemberLoginFlag();
    },
    esvShow() {

    },
    methods: {
        queryMemberLoginFlag() {
            const ths = this;
            this.$doRequest(
                {
                    url: '/account/queryMemberLoginFlag',
                    params: {
                        merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                    },
                    before: function() {
                        ths.loading = toastLoading();
                        ths.pageShow = false;
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                        ths.pageShow = true;
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        console.log(1);
                        ths.loginFlag = data.result;
                    } else {
                        Toast(data.message);
                    }
                    ths.pageShow = true;
                }
            );
        },
        getCode(url) {
            const strs = url.split('?');
            const str = strs[strs.length - 1];

            return str.split('=')[1];
        },
        submitForm() {
            const params = { ...this.ruleForm, merchantInfo: JSON.stringify(this.merchantInfoSwitch) };
            const { mobilePhone, ivalidateCode, accountIdCard, accountTrueName, accountInvitationCode } = params;
            // 表单验证
            if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(mobilePhone)) && !this.loginFlag) {
                Toast('手机号码格式不正确');
                return false;
            } else if (!(/^\d{4}$/).test(ivalidateCode) && !this.loginFlag) {
                Toast('请填写正确的验证码');
                return false;
            } else if (!(/^[\u4e00-\u9fa5]+$/).test(accountTrueName)) {
                Toast('请填写中文名');
                return false;
            } else if (!(/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(accountIdCard))) {
                Toast('请填写正确的身份证号码');
                return false;
            } else if (accountInvitationCode && accountInvitationCode.length !== 6) {
                Toast('请填写正确的邀请码' + accountInvitationCode.length);
                return false;
            }
            // 请求接口
            if (this.loginFlag) {
                // 已登录
                this.openRetailStoreMember(params, '/account/openRetailStoreMemberWithLogin');
            } else {
                // 未登录
                this.openRetailStoreMember(params, '/account/openRetailStoreMemberWithoutLogin');
            }
        },
        openRetailStoreMember(params, url) {
            const ths = this;
            this.$doRequest(
                {
                    url,
                    params,
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    // console.log(data.result);
                    // ths.isDistribution = data.result;
                    if (data.responseCode === '100000') {
                        if (data.result.accountReviewStatus === 3) {
                            ths.esvOpenPage('OPOpenSuccess');
                            // ths.queryMemberAccountDetail();
                            ths.commonJs.putLocalStorage(
                                'accountDetail',
                                data.result);
                        } else {
                            ths.esvOpenPage('OPMembercenter');
                        }
                    }
                }
            );
        },
        timeCount() {
            var self = this;
            self.timeDao = setInterval(function() {
                if (self.codeTime < 1) {
                    self.codeButton = true;
                    self.codeMsg = '重新发送';
                    clearInterval(self.timeDao);
                    self.codeTime = 60;
                } else {
                    self.codeButton = false;
                    self.codeTime--;
                    self.codeMsg = self.codeTime + 's后重新发送';
                }
            }, 1000);
        },
        // 发送验证码
        handleCode() {
            const self = this;
            self.$toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true // 禁用背景点击
            });
            const phone = this.ruleForm.mobilePhone;
            if ((/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(phone))) {
                self.$doRequest({
                    url: '/user/smsSend',
                    params: {
                        mobileNumber: phone.trim(),
                        merchantInfo: JSON.stringify(this.merchantInfoSwitch)
                    },
                    before: function() {
                        self.loading = toastLoading();
                    },
                    complete: function() {
                        clearToastLoading(self.loading);
                    }
                },
                function (data) {
                    if (data.responseCode === '100000') {
                        Toast('短信验证码发送成功');
                        self.timeCount();
                    } else {
                        Toast(data.message);
                    }
                });
            } else {
                self.$toast.clear();
                if (!phone) {
                    Toast('请填写手机号码');
                } else {
                    Toast('手机号码格式不正确');
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'merchantInfoSwitch'
        ])
    },
    watch: {
        ruleForm: {
            handler(curVal) {
                // 总觉得可以再优化一下（标记）
                // 判断表单中是否所有必填都有值了
                const arr = ['mobilePhone', 'ivalidateCode', 'accountTrueName', 'accountIdCard', 'accountInvitationCode'];
                let count;
                if (this.loginFlag) {
                    count = 2;
                } else {
                    count = 0;
                }
                arr.forEach(item => {
                    if ((curVal[item] && curVal[item].length > 0) || item === 'accountInvitationCode') {
                        count++;
                    }
                });
                if (count >= 5) {
                    this.btndisabled = false;
                }
                // console.log(i);
            },
            deep: true
        }
    },
    components: {
        wxShareLoading: () => import('@/components/common/wxShareLoading')
    }
};
</script>

<style lang="scss" scoped>
#openDistribution {
    // height: 100%;
    .header-img {
        background: url('../assets/img/fenxiao/header@3x.png') no-repeat center;
        background-size: cover;
        height: 160px;
    }
    .van-cell {
        line-height: 30px;
    }
    .send-btn {
        border: none;
        border-radius: 0;
        background: white;
        color: $primary-color;
        font-size: 14px;
    }
    .sended{
        color: #999;
    }
    footer {
        padding: 0 24px;
        position: absolute;
        width: 100%;
        bottom: 41px;
        .submit-btn {
            // position: absolute;

            background: #EE2E50;
            border-radius: 22px;
            text-align: center;
            height: 44px;
            line-height: 44px;
            font-size: 14px;
            color: #FFFFFF;
            margin-top: 0;
        }
    }
    @media screen and (max-height: 510px){
        footer {
            padding: 0 24px;
            position:static;
            width: 100%;
            margin-top: 10px;
            bottom: 41px;
        }
    }
}
</style>
